import React from 'react';
import { Helmet } from 'react-helmet';
import ContactUs from './ContactUs';

const Contact = () => (
  <>
    <Helmet>
      <title>Contact Us | MilaajBrandset</title>
      <meta
        name="description"
        content="Get in touch with MilaajBrandset. Whether you have questions about our services or need support, we're here to help you."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, contact us, customer support, digital solutions, business inquiries"
      />
      <meta property="og:title" content="Contact Us | MilaajBrandset" />
      <meta
        property="og:description"
        content="Get in touch with MilaajBrandset. Whether you have questions about our services or need support, we're here to help you."
      />
    </Helmet>
    <ContactUs />
  </>
);

export default Contact;